import { Route } from "react-router-dom";

import { ShowProvider } from "../../../providers";
import { TvVideosPage } from "../Videos/TvVideosPage";
import { TvVideoShow } from "../Videos/TvVideoShow";
import { TvShowsPage } from "../Shows/TvShowsPage";
import { TvShowShow } from "../Shows/TvShowShow";
import { TvCollectionsPage } from "../Collections/TvCollectionsPage";
import { TvCollectionShow } from "../Collections/TvCollectionShow";
import { TvShowcasePage } from "../Showcase/TvShowcasePage";
import { TvSlideShow } from "../Showcase/TvSlideShow";
import { TvLeaguesPage } from "../Leagues/TvLeaguesPage";
import { TvMatchesPage } from "../Matches/TvMatchesPage";
import { TvSettingsPage } from "../Settings/TvSettingsPage";

const page = (key: string, path: string, element: JSX.Element) => (
  <Route
    key={key}
    path={path}
    element={<ShowProvider>{element}</ShowProvider>}
  />
);

export const TV_ROUTES = [
  page("tv-videos", "tv/videos", <TvVideosPage />),
  page("tv-videos-create", "tv/videos/create", <TvVideoShow />),
  page("tv-videos-show", "tv/videos/:id", <TvVideoShow />),
  page("tv-shows", "tv/shows", <TvShowsPage />),
  page("tv-shows-create", "tv/shows/create", <TvShowShow />),
  page("tv-shows-show", "tv/shows/:id", <TvShowShow />),
  page("tv-collections", "tv/collections", <TvCollectionsPage />),
  page("tv-collections-create", "tv/collections/create", <TvCollectionShow />),
  page("tv-collections-show", "tv/collections/:id", <TvCollectionShow />),
  page("tv-showcase", "tv/showcase", <TvShowcasePage />),
  page("tv-showcase-create", "tv/showcase/create", <TvSlideShow />),
  page("tv-showcase-show", "tv/showcase/:id", <TvSlideShow />),
  page("tv-leagues", "tv/leagues", <TvLeaguesPage />),
  page("tv-matches", "tv/matches", <TvMatchesPage />),
  page("tv-settings", "tv/settings", <TvSettingsPage />),
];
